var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as actions from 'app/actions/retransmission-status';
import http from 'app/services/http';
const initialState = {
    status: null,
    devices: null,
    isLoading: false,
    devicesLoading: false,
    error: null,
    devicesError: null,
};
export const retransmissionStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.SET_STATUS: {
            const { status } = action.payload;
            return Object.assign(Object.assign({}, state), { status: status !== null && status !== void 0 ? status : null });
        }
        case actions.SET_DEVICES: {
            const { channel, devices } = action.payload;
            return Object.assign(Object.assign({}, state), { devices: { channel: channel !== null && channel !== void 0 ? channel : '', devices: devices !== null && devices !== void 0 ? devices : [] } });
        }
        case actions.SET_LOADING: {
            const { isLoading, target } = action.payload;
            if (target === 'devices') {
                return Object.assign(Object.assign({}, state), { devicesLoading: Boolean(isLoading) });
            }
            return Object.assign(Object.assign({}, state), { isLoading: Boolean(isLoading) });
        }
        case actions.SET_ERROR: {
            const { error, target } = action.payload;
            if (target === 'devices') {
                return Object.assign(Object.assign({}, state), { devicesError: error !== null && error !== void 0 ? error : null });
            }
            return Object.assign(Object.assign({}, state), { error: error !== null && error !== void 0 ? error : null });
        }
        default:
            return state;
    }
};
// Thunks
export function statusLoad() {
    return function statusLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            dispatch(actions.setLoading(true));
            try {
                const response = yield http.get('/retransmission/status');
                dispatch(actions.setStatus(response.data));
                dispatch(actions.setError(null));
                return { success: true };
            }
            catch (error) {
                // http-interceptor отдаёт error.response (axios response: status, data).
                // При network-error interceptor reject'ит undefined — приводим к null для редьюсера.
                dispatch(actions.setError((_a = error) !== null && _a !== void 0 ? _a : null));
                return { success: false, error };
            }
            finally {
                dispatch(actions.setLoading(false));
            }
        });
    };
}
export function devicesLoad(channel) {
    return function devicesLoadThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            dispatch(actions.setDevices(channel, []));
            dispatch(actions.setLoading(true, 'devices'));
            dispatch(actions.setError(null, 'devices'));
            const isRequestedChannel = () => { var _a, _b; return ((_b = (_a = getState().retransmissionStatus) === null || _a === void 0 ? void 0 : _a.devices) === null || _b === void 0 ? void 0 : _b.channel) === channel; };
            try {
                // channel содержит двоеточие (например rnis:GPN) — кодируем для URL.
                const response = yield http.get(`/retransmission/status/${encodeURIComponent(channel)}/devices`);
                // Игнорируем ответ, если канал уже закрыт или открыт другой.
                if (!isRequestedChannel()) {
                    return { success: true };
                }
                dispatch(actions.setDevices(channel, ((_a = response.data) === null || _a === void 0 ? void 0 : _a.devices) || []));
                return { success: true };
            }
            catch (error) {
                if (isRequestedChannel()) {
                    dispatch(actions.setError((_b = error) !== null && _b !== void 0 ? _b : null, 'devices'));
                }
                return { success: false, error };
            }
            finally {
                if (isRequestedChannel()) {
                    dispatch(actions.setLoading(false, 'devices'));
                }
            }
        });
    };
}
export default retransmissionStatusReducer;
